import { EducationLevel } from "src/types";

export const tertiaryQualifications = [
	EducationLevel.OND,
	EducationLevel.HND,
	EducationLevel.BACHELORS,
	EducationLevel.MASTERS,
	EducationLevel.DOCTORATE,
];
